import { ComponentAPI } from '@philips-internal/oswald-ui-core';
class UserProfileApi extends ComponentAPI {
}
export default UserProfileApi;
//# sourceMappingURL=user-profile-api.js.map